export type TShippingSection = {
  key: string;
  paragraphs?: readonly string[];
  bullets?: readonly string[];
};

export const SHIPPING_SECTIONS: readonly TShippingSection[] = [
  {
    key: 'processing',
    paragraphs: ['line1'],
  },
  {
    key: 'shipping.time',
    paragraphs: ['line1'],
    bullets: ['item1', 'item2'],
  },
  {
    key: 'shipping.cost',
    paragraphs: ['line1'],
  },
  {
    key: 'courier.delays',
    paragraphs: ['line1'],
  },
] as const;
